import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SearchImg from "../../../assets/provider/images/search1.svg";
import { api } from "../../../utlis/provider/api.utlis";
import { routes } from "../../../utlis/provider/routes.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import CallImg from "../../../assets/user/images/call.svg";
import SmsImg from "../../../assets/user/images/sms.svg";
import moment from "moment";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { decode, encode } from "base-64";

const MatchedApplicant = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [applicant, setApplicant] = useState();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const localData = useLocation();
  const id = localData.state?.id;

  const getMatchedApplicant = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all matched applicant => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setApplicant(response?.data?.data);
    } else setApplicant();
    setLoading(false);
  };

  const handleFilter = (e, fromDate = null, toDate = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    getMatchedApplicant(
      api.matchedApplicant + `?search=${name}&jobId=${decode(id)}`
    );
  };

  const subscriptionAuth = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      if (!response.data.data.accessMatchedProfileScreen) {
        navigate(routes.subscriptionPlan);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getMatchedApplicant(api.matchedApplicant + `?jobId=${decode(id)}`);
    subscriptionAuth(api.subscriptionAuth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="carenetwork-section">
          <div className="care-title-header">
            <h2 className="heading-title">
              <Link
                className="btn-back"
                to=""
                onClick={(e) => {
                  e.preventDefault();
                  navigate(-1);
                }}
              >
                <i className="mdi mdi-arrow-left-thin"></i>
              </Link>
              &nbsp;Matched Applicants
            </h2>
            <Link
              className="bottom-buttons"
              to={routes.addPost}
              title="Add Post"
            >
              <i className="fa fa-plus"></i>
            </Link>
            <div className="search-filter wd70">
              <div className="row g-2">
                <div className="col-md-3">
                  {/* <div className="form-group">
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={fromDate}
                      onChange={(date, e) => {
                        setFromDate(date);
                        handleFilter(e, date, toDate ?? "");
                      }}
                      className="form-control"
                      style={{ padding: "15px 40px" }}
                      isClearable
                      autoComplete="off"
                      name="date"
                      placeholderText="From Date"
                    />
                  </div> */}
                </div>

                <div className="col-md-3">
                  {/* <div className="form-group">
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={toDate}
                      onChange={(date, e) => {
                        setToDate(date);
                        handleFilter(e, fromDate, date);
                      }}
                      className="form-control"
                      style={{ padding: "15px 40px" }}
                      isClearable
                      autoComplete="off"
                      name="date"
                      placeholderText="To Date"
                    />
                  </div> */}
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <div className="search-form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carenetwork-content">
            <div className="row g-3">
              {applicant?.applicants?.length !== 0 &&
              applicant?.applicants?.length != undefined &&
              applicant?.applicants?.length != null ? (
                applicant?.applicants?.map((ele, indx) => {
                  return (
                    <div key={indx} className="col-md-4">
                      <div className="care-card mb-0">
                        <div className="care-card-head">
                          <div className="care-id">
                            Job ID:{" "}
                            <span>{applicant?.postDetail?.job_id ?? "NA"}</span>
                          </div>

                          <div className="care-date">
                            Job Posted On:{" "}
                            <span>
                              {moment(ele.created_date).format("MM-DD-yyyy")}
                            </span>
                          </div>
                        </div>
                        <div className="care-card-body">
                          <div className="care-content">
                            <div className="title-text">
                              {applicant?.postDetail?.title ?? "NA"}
                            </div>

                            <div className="jobs-point">
                              <div className="jobs-point-item">
                                {ele.applicant_name ?? "NA"}
                              </div>
                              <div className="jobs-point-item">
                                <img src={CallImg} />{" "}
                                <span>{ele?.user?.mobile ?? "NA"}</span>
                              </div>
                              <div className="jobs-point-item">
                                <img src={SmsImg} />{" "}
                                <span>{ele.applicant_email ?? "NA"}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="care-card-foot">
                          <div className="care-action">
                            {ele.resume !== null &&
                            ele.resume !== undefined &&
                            ele.resume !== "" ? (
                              <Link
                                className="btn-bl"
                                target="_blank"
                                to={ele.resume}
                              >
                                Download Resume/CV
                              </Link>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MatchedApplicant;
